export default __webpack_public_path__ + "static/media/vire6.79c58bcb.jpg";